import { Modal } from './Modal';

export { Base } from './Base';
export { Prompt } from './Prompt';
export { TwoColumnModal } from './TwoColumnModal';

export default Modal;
